// extracted by mini-css-extract-plugin
export var Divider = "LoyaltyStats-module--Divider--385f3";
export var LoyaltyProfileContainer = "LoyaltyStats-module--LoyaltyProfileContainer--07c02";
export var StatLabel = "LoyaltyStats-module--StatLabel--c2560";
export var StatRecord = "LoyaltyStats-module--StatRecord--aa78c";
export var StatValue = "LoyaltyStats-module--StatValue--b11b8";
export var UserStats = "LoyaltyStats-module--UserStats--23a17";